module.exports = __webpack_public_path__ + "img/5.428dfdc2.jpg";